import type { FetchOptions, FetchRequest } from 'ofetch';
import { $fetch } from 'ofetch';
import { useRuntimeConfig } from '#app/nuxt';
import { useProjectApiBaseUrl } from '#layers/base';
import { FETCH_TIMEOUT_MS } from '~/constants/fetch';

type FetchFunction = <
	DefaultT = unknown,
	DefaultR extends FetchRequest = FetchRequest,
	T = DefaultT,
	R extends FetchRequest = DefaultR,
	O extends FetchOptions = FetchOptions,
>(
	endpoint: R,
	options?: Omit<O, 'baseURL'>,
) => Promise<T>;

/**
 * Returns a fetch function scoped to the system API (no project slug).
 * Use this for system-level endpoints like `/system/invites`.
 */
export function useSystemFetch(): FetchFunction {
	const runtimeConfig = useRuntimeConfig();

	return $fetch.create({
		baseURL: runtimeConfig.public.api,
		timeout: FETCH_TIMEOUT_MS,
	}) as FetchFunction;
}

const projectFetch: FetchFunction = (endpoint, options) => $fetch(endpoint, {
	baseURL: useProjectApiBaseUrl(),
	timeout: FETCH_TIMEOUT_MS,
	...options,
}) as Promise<any>;

export function useProjectFetch() {
	return projectFetch;
}
